import React from 'react';
import PropTypes from 'prop-types';
import BabyEditContainer from '../containers/BabyEditContainer';
import Modal from './Modal';

export default function BabyEditorModal({
  initialValues = null,
  isOpen,
  onRequestClose,
  onBabySaved
}) {
  if (!initialValues) {
    return null;
  }
  
  return (
    <Modal isOpen={isOpen} onRequestClose={onRequestClose}>
      <BabyEditContainer
        baby={initialValues}
        onRequestClose={onRequestClose}
        onBabySaved={onBabySaved}
        onCancelClicked={onRequestClose}
      />
    </Modal>
  );
}

BabyEditorModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  onBabySaved: PropTypes.func.isRequired,
  initialValues: PropTypes.shape({
    colorScheme: PropTypes.string.isRequired
  })
};
